import {
  Component,
  Inject,
  OnInit
} from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { DialogWithFormBase } from "../../types/DialogWithFormBase";
import { DialogHeaderComponent } from "../dialog-header/dialog-header.component";
import { MatButtonModule } from "@angular/material/button";

@Component({
  standalone: true,
  imports: [
    DialogHeaderComponent,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
  ],
  template: `
    <terra-dialog-header>
    <h1>File Rename</h1>
  </terra-dialog-header>
    <div >
        <mat-form-field color="primary" appearance="outline" class="w-full">
          <input matInput type="text" [formControl]="title" class="example-right-align" placeholder="Enter new file name" />
          <span matTextSuffix>.{{getFileExtension(this.data.title)}}</span>
        </mat-form-field>
    </div>
    <mat-dialog-actions>
      <button type="submit" mat-flat-button color="primary" class="page-cta" [disabled]="title.invalid" [mat-dialog-close]="newFileName" >
        Rename
      </button>
      <button [mat-dialog-close]="undefined" type="button" mat-button color="primary"  class="cancel-button tall-button">
        Cancel
      </button>
  </mat-dialog-actions>
  `,
  styles: `
  
  `,
})
export class FileRenameDialogComponent extends DialogWithFormBase implements OnInit{
  constructor( @Inject(MAT_DIALOG_DATA) public data){
    super();
  }

  title: FormControl<string> = new FormControl('', [Validators.required]);

  get newFileName(): string {
    return `${this.title.value}.${this.getFileExtension(this.data.title)}`;
  }

  ngOnInit(): void {
    this.title.setValue(this.getFileName(this.data.title));
  }


  getFileExtension(filename?: string): string {
    return filename?.split('.').pop() || '';
  }

  getFileName(filename?: string): string {
    return filename?.split('.').shift() || '';
  }
}